import { factory, getResponseDefault } from '@repo-level/core-front';

export interface Jackpots {
  [currencyCode: string]: {
    [id: string]: number;
  };
}

// use default transformResponse
export const jackpots = factory(
  (r) => () =>
    r<Jackpots>('get', 'games/jackpots', undefined, {
      transformResponse: [getResponseDefault()],
    })
);

export interface TotalJackpots {
  [currencyCode: string]: number;
}

// use default transformResponse
export const totalJackpots = factory(
  (r) => () =>
    r<TotalJackpots>('get', 'games/total_jackpots', undefined, {
      transformResponse: [getResponseDefault()],
    })
);
